<template>

    <div>
        <section class="dashboard-area">
            <div class="dashboard_menu_area" v-if="user && currentUserData && user.id === currentUserData.id">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <ul class="dashboard_menu">
                                <li :class="{active: stateCurrentComponent === 'profile-component' || stateCurrentComponent === 'volunteer-backend-profile-component'}">
                                    <a class="cursor-pointer" @click="setComponent('profile-component')">
                                        <span class="icon icon-profile"></span>
                                        {{$store.getters.t('main_menu_profile')}}
                                    </a>
                                </li>
                                <li :class="{active: stateCurrentComponent === 'dashboard-component'}">
                                    <a class="cursor-pointer" @click="setComponent('dashboard-component')">
                                        <span class="icon icon-dashboard"></span>
                                        {{$store.getters.t('main_menu_dashboard')}}
                                    </a>
                                </li>
                                <li :class="{active: stateCurrentComponent === 'notification-component' || stateCurrentComponent === 'volunteer-backend-notification-component'}">
                                    <a class="cursor-pointer" @click="setComponent('notification-component')">
                                        <span class="icon icon-notice"></span>
                                        {{$store.getters.t('main_menu_notifications')}}
                                    </a>
                                </li>
                                <li :class="{active: stateCurrentComponent === 'settings-component' || stateCurrentComponent === 'volunteer-backend-settings-component'}">
                                    <a class="cursor-pointer" @click="setComponent('settings-component')">
                                        <span class="icon icon-setting"></span>
                                        {{$store.getters.t('main_menu_profile_settings')}}
                                    </a>
                                </li>

                                <li :class="{active: stateCurrentComponent === 'pets-component' || stateCurrentComponent === 'volunteer-backend-pets-component'}">
                                    <a class="cursor-pointer" @click="setComponent('pets-component')">
                                        <span class="icon icon-less"></span>
                                        {{$store.getters.t('main_menu_my_wards')}}
                                    </a>
                                </li>
                                <li :class="{active: stateCurrentComponent === 'finances-component'}">
                                    <a class="cursor-pointer" :href="`/volunteer/${currentUserData.id}/finance-report`">
                                        <span class="icon icon-transaction"></span>
                                        {{$store.getters.t('main_menu_transactions')}}
                                    </a>
                                </li>
                            </ul>
                            <!-- end /.dashboard_menu -->
                        </div>
                        <!-- end /.col-md-12 -->
                    </div>
                    <!-- end /.row -->
                </div>
                <!-- end /.container -->
            </div>
            <!-- end /.dashboard_menu_area -->
            <transition name="component-fade" mode="out-in">
                <component :is="current" :user="user"></component>
            </transition>

        </section>
    </div>


</template>

<script>

import {mapGetters, mapMutations} from 'vuex';

import Profile from './VolunteerBackendProfileComponent';
import Notifications from './VolunteerBackendNotificationComponent';
import Settings from './VolunteerBackendSettingsComponent';
import Pets from './VolunteerBackendPetsComponent';
import Dashboard from './Profile/volunteer/UserDashboard';

export default {
    components: {Profile,Notifications,Settings,Pets, Dashboard},
    data() {
        return {
            appRoutes: null,
            formData: {
                phone: null
            },
        }
    },
    props: ['user'],
    created(){
        this.appRoutes = window.appRoutes;

        if(!this.stateCurrentComponent) this.setComponent('profile-component')

        if(!this.currentUserData || (+this.currentUserData.id !== +this.user.id)){
            this.setComponent('profile-component')
        }
    },
    computed: {

        ...mapGetters({
            stateCurrentComponent: 'getterProfileTab',
            stateProfileType: 'getUserProfileType'
        }),

        currentUserData() {
            return this.$store.getters.getUserData;
        },

        current(){

            let component = null;

            if(  this.currentUserData  &&  +this.currentUserData.id  ===  +this.user.id  ) {

                switch (this.stateCurrentComponent){
                    case "profile-component":
                    case "volunteer-backend-profile-component":
                        component = 'Profile'
                        break;
                    case "dashboard-component":
                        component = 'Dashboard';
                        break;
                    case "notification-component":
                    case "volunteer-backend-notification-component":
                        component = 'Notifications'
                        break;
                    case "settings-component":
                    case "volunteer-backend-settings-component":
                        component = 'Settings'
                        break;
                    case "pets-component":
                    case "volunteer-backend-pets-component":
                        component = 'Pets'
                        break;
                    default:
                        break;
                }

                return component

            }

            return component = 'Profile'


        }


    },
    methods: {
        ...mapMutations({
            setComponent: 'setterProfileTab',
            setProfileType: 'setUserProfileType'
        }),

    },
    watch: {
        currentUserData(){
            if(this.currentUserData && (+this.currentUserData.id === +this.user.id)){

                if( this.stateProfileType  !== 'zooprotection' ) this.setProfileType('zooprotection')

            }
        }
    }
}
</script>

<style lang="scss" scoped>

.component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active до версии 2.1.8 */
{
    opacity: 0;
}
</style>
